module.exports = __webpack_public_path__ + "static/media/apk_popup_desktop.e3e922e3.webp";